var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-list',{attrs:{"clients":_vm.clients,"others":_vm.othersAll,"all":_vm.allPhone,"chat-or-phone":'PHONE'}})}
var staticRenderFns = []

export { render, staticRenderFns }